var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { professionalStatusEntityName } from '../../../../backend/config/classifiers/entities/defineProfessionalStatusClassifier';
import { useOccupationCredentialStorage } from '../../../../ui/hooks';
import { isTrainFeatureEnabled } from '../../../../ui/utils';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { usePublicDataGet } from '@juvare/platform-sdk-react/ui/hooks';
import { useEffect, useState } from 'react';
export function useCredentialingFormParams(settings, userState) {
    var _a, _b;
    const [professionalStatusCredentialId, setProfessionalStatusCredentialId] = useState();
    const occupationCredentialStorage = useOccupationCredentialStorage();
    const professionalStatuses = usePublicDataGet(`classifier-${professionalStatusEntityName}`);
    useEffect(() => {
        if (professionalStatusCredentialId || !userState)
            return;
        const fetchProfessionalStatus = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const professionalStatusCredential = yield occupationCredentialStorage.list({
                    filter: [{ column: 'name', op: '=', value: 'Professional Status' }],
                    limit: 1,
                });
                setProfessionalStatusCredentialId((_a = professionalStatusCredential.rows[0]) === null || _a === void 0 ? void 0 : _a.id);
            }
            catch (error) {
                handleErrorSnackbar(error);
            }
        });
        fetchProfessionalStatus();
    }, [professionalStatusCredentialId, occupationCredentialStorage, userState]);
    return {
        professionalStatuses: (_a = professionalStatuses.data) !== null && _a !== void 0 ? _a : [],
        esarVhpCode: (_b = settings.esarVhp) === null || _b === void 0 ? void 0 : _b.clientCode,
        showTrainIntegrationFields: isTrainFeatureEnabled(userState),
        professionalStatusCredentialId,
    };
}
